// Centralised site nav + image constants used across all pages.
export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/founder", label: "Founder" },
  { to: "/services", label: "Services" },
  { to: "/training-programs", label: "Training Programs" },
  { to: "/pre-trip-inspection", label: "Pre-Trip Inspection" },
  { to: "/safety-topics", label: "Safety Topics" },
  { to: "/for-trainees", label: "For Trainees" },
  { to: "/for-districts", label: "For Districts" },
  { to: "/pretrip-guide", label: "Pretrip Guide" },
  { to: "/training-materials", label: "Training Materials" },
  { to: "/resources", label: "Resources" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

// Audience-based grouped navigation shown at the top of every page.
export const NAV_GROUPS = [
  {
    key: "trainees",
    label: "New Trainees",
    description: "Start your school bus driver journey.",
    items: [
      { to: "/for-trainees", label: "Overview", desc: "What CLB Solution offers new drivers." },
      { to: "/training-programs", label: "Training Programs", desc: "New driver, pre-trip mastery, behind-the-wheel." },
      { to: "/pre-trip-inspection", label: "Pre-Trip Inspection", desc: "Full inside & outside inspection training." },
      { to: "/safety-topics", label: "Safety Topics", desc: "Mirror use, danger zones, loading & more." },
      { to: "/training-materials", label: "Training Materials", desc: "Plain-language study handouts & checklists." },
    ],
  },
  {
    key: "districts",
    label: "Districts & Contractors",
    description: "Workforce and training support for transportation departments.",
    items: [
      { to: "/for-districts", label: "Overview", desc: "How CLB Solution supports districts." },
      { to: "/services", label: "Services", desc: "Training support, workshops, evaluations." },
      { to: "/training-materials", label: "Training Materials", desc: "Reusable handouts & instructor checklists." },
      { to: "/resources", label: "Resources", desc: "Future study guides and articles." },
    ],
  },
  {
    key: "experienced",
    label: "Experienced Drivers",
    description: "Refresher and corrective training for returning or veteran drivers.",
    items: [
      { to: "/services", label: "Refresher & Corrective Training", desc: "Rebuild confidence, correct unsafe habits." },
      { to: "/pre-trip-inspection", label: "Pre-Trip Refresh", desc: "Sharpen your inspection routine." },
      { to: "/safety-topics", label: "Safety Topics Review", desc: "Mirror use, backing, tail swing & more." },
      { to: "/resources", label: "Resources", desc: "Guides and driver tips." },
    ],
  },
];

// Everything that is NOT already in the top nav groups (About / Founder / FAQ)
// lives in the hamburger + footer.
export const SECONDARY_LINKS = [
  { to: "/about", label: "About" },
  { to: "/founder", label: "Founder" },
  { to: "/faq", label: "FAQ" },
];

// Direct top-level links (no dropdown).
export const PRIMARY_LINKS = [
  { to: "/", label: "Home" },
  { to: "/pretrip-guide", label: "Pretrip App" },
  { to: "/contact", label: "Contact" },
];

export const IMAGES = {
  heroHome:
    "https://images.unsplash.com/photo-1583508805133-8fd03a9916d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxzY2hvb2wlMjBidXN8ZW58MHx8fHwxNzgyNzc0MjM0fDA&ixlib=rb-4.1.0&q=85",
  founder: "/images/curtis-brown.png",
  preTrip:
    "https://images.unsplash.com/photo-1766716973087-8c6998794a9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxidXMlMjBtaXJyb3J8ZW58MHx8fHwxNzgyNzc0MjM0fDA&ixlib=rb-4.1.0&q=85",
  services:
    "https://images.pexels.com/photos/19760978/pexels-photo-19760978.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  safetyTopics:
    "https://images.unsplash.com/photo-1612185079032-79b1a9932a3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxidXMlMjBkcml2ZXIlMjBzdGVlcmluZyUyMHdoZWVsfGVufDB8fHx8MTc4Mjc3NDIzNHww&ixlib=rb-4.1.0&q=85",
};

export const BRAND = {
  name: "CLB Solution LLC",
  motto: "Coach · Learn · Build",
  email: "clbsolutionllc@gmail.com",
  location: "Delaware-based with future expansion.",
  status: "Currently preparing for launch.",
};
